import {ADDRESS} from "../../../../_api/client";


const First1 = `${ADDRESS}/images/about/1/photo_5370909075719701634_y.jpg`
const First2 = `${ADDRESS}/images/about/1/photo_5370909075719701635_y.jpg`
const First3 = `${ADDRESS}/images/about/1/photo_5370909075719701636_y.jpg`

const First4 = `${ADDRESS}/images/about/1/photo_5370909075719701637_y.jpg`

const Second1 = `${ADDRESS}/images/about/2/photo_5370909075719701639_y.jpg`
const Third1 = `${ADDRESS}/images/about/3/photo_5370909075719701645_y.jpg`

const Third2 = `${ADDRESS}/images/about/3/photo_5370909075719701647_y.jpg`

const Fourth1 = `${ADDRESS}/images/about/4/photo_5370909075719701641_y.jpg`

const Fifth1 = `${ADDRESS}/images/about/5/photo_5370909075719701642_y.jpg`
const Sixth1 = `${ADDRESS}/images/about/6/photo_5370909075719701653_y.jpg`



export const first = First1
export const second = Second1
export const third = Third1
export const fourth = Fourth1
export const fifth = Fifth1
export const sixth = Sixth1

export const firsts = [First1, First2, First3, First4]
export const seconds = [Second1]
export const thirds = [Third1, Third2]
export const fourths = [Fourth1]
export const fifths = [Fifth1]
export const sixths = [Sixth1]